module.exports = __webpack_public_path__ + "static/media/montage.094f2152.jpg";